import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useGame } from '../context/GameContext';
import { WinAnimation } from '../components/WinAnimation';
import './CasinoWheel.css';

const SEGMENTS = [1, 2, 5, 10, 20, 50, 100, 200, 500, 0.5];

export function CasinoWheel() {
  const { gameState, placeBet, addBalance, setLastWin, recordSpin, betOptions } = useGame();
  const [spinning, setSpinning] = useState(false);
  const [result, setResult] = useState<number | null>(null);
  const [lastWin, setLastWinLocal] = useState(0);
  const [showWinAnim, setShowWinAnim] = useState(false);

  const canSpin = gameState.balance >= gameState.bet && !spinning;

  const spin = useCallback(() => {
    if (!canSpin) return;
    const bet = gameState.bet;
    addBalance(-bet);
    setSpinning(true);
    setResult(null);

    setTimeout(() => {
      const idx = Math.floor(Math.random() * SEGMENTS.length);
      const multiplier = SEGMENTS[idx];
      const win = bet * multiplier;
      setResult(multiplier);
      if (win > 0) {
        setLastWin(win);
        setLastWinLocal(win);
        setShowWinAnim(true);
        recordSpin(true);
      } else recordSpin(false);
      setSpinning(false);
    }, 3000);
  }, [canSpin, gameState.bet, addBalance, setLastWin, recordSpin]);

  return (
    <div className="casino-wheel">
      {showWinAnim && lastWin > 0 && (
        <WinAnimation amount={lastWin} isBonus={result! >= 20} onEnd={() => setShowWinAnim(false)} />
      )}
      <div className="casino-wheel-container">
        <Link to="/" className="casino-back">← Takaisin</Link>
        <div className="casino-balance-bar">
          <span className="balance-value">€{gameState.balance}</span>
          <select value={gameState.bet} onChange={(e) => placeBet(Number(e.target.value))} disabled={spinning} className="bet-select">
            {betOptions.map((b) => (
              <option key={b} value={b}>€{b % 1 ? b.toFixed(1) : b}</option>
            ))}
          </select>
        </div>
        <h1 className="wheel-title">🪐 Onnenpyörä</h1>
        <p className="wheel-rules">Pyöräytä – voitto 0.5× – 500×</p>
        <div className={`wheel-circle ${spinning ? 'spinning' : ''}`}>
          <div className="wheel-pointer">▼</div>
          <div className="wheel-segments">
            {SEGMENTS.map((s, i) => (
              <span key={i} className="wheel-seg">{s}×</span>
            ))}
          </div>
        </div>
        {result !== null && (
          <div className="wheel-result">
            {result === 0 ? 'Ei voittoa' : `Voitto: ${result}× = €${(gameState.bet * result).toFixed(2)}`}
          </div>
        )}
        <button type="button" className="spin-button" onClick={spin} disabled={!canSpin}>
          {spinning ? 'Pyörii...' : `Pyöräytä €${gameState.bet}`}
        </button>
      </div>
    </div>
  );
}
